module.exports = __webpack_public_path__ + "img/fu-poster-code.4c865a78.jpg";